export default __webpack_public_path__ + "static/media/rec.9610501f.jpeg";